import { environment } from '../environments/environment';

export const prepareApiUrl = (method: string): string => {
  return `${environment.baseUrl}${method}`;
};

export const prepareClientFormApiUrl = (method: string): string => {
  return prepareApiUrl(`${environment.clientFormController}/${method}`);
};

export const prepareAttendanceFormApiUrl = (method: string): string => {
  return prepareApiUrl(`${environment.attendanceFormController}/${method}`);
};

export const prepareQuestionnaireApiUrl = (method: string): string => {
  return prepareApiUrl(`${environment.questionnaireController}/${method}`);
};

export const unsaveConfirm = (message?: string) => {
  if (confirm(message ?? 'You have unsaved changes! Are you sure you want to leave?')) {
    return true;
  } else {
    return false;
  }
};

export const confirmLoadUnsavedChanges = (message?: string) => {
  if (confirm(message ?? 'We have detected unsaved changes. Press ok to load and cancel to ignore?')) {
    return true;
  } else {
    return false;
  }
};